// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assignment-timeline__wrapper[data-v-06039f72] {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
